import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

export const productModules = [
  { id: "content_radar", label: "Content Radar" },
  { id: "fast_tracking", label: "Fast tracking" },
  { id: "research", label: "Research" },
  { id: "draft_creator", label: "Draft Creator" },
  { id: "social_studio", label: "Social Studio" },
  { id: "social_listening", label: "Social Listening" },
  { id: "distribution", label: "Distribution Hub" },
  { id: "idea_sparker", label: "Idea Sparker" },
];

export function ModuleGrid({
  value,
  onChange,
  disabled = false,
}: {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
}) {
  const selected = new Set(value);
  return (
    <Box>
      <Typography variant="caption" sx={{ color: "#a1a1aa", display: "block", mb: 0.5 }}>
        Available in
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "1fr 1fr 1fr" },
          columnGap: 1,
          rowGap: 0.25,
        }}
      >
        {productModules.map((module) => (
          <FormControlLabel
            key={module.id}
            disabled={disabled}
            sx={{ color: "#e4e4e7", m: 0, alignItems: "center" }}
            control={
              <Checkbox
                size="small"
                checked={selected.has(module.id)}
                onChange={(_, checked) => {
                  const next = checked ? [...value, module.id] : value.filter((id) => id !== module.id);
                  onChange(next);
                }}
                sx={{ color: "#71717a", p: 0.5, "&.Mui-checked": { color: "#a5b4fc" } }}
              />
            }
            label={<Typography variant="body2">{module.label}</Typography>}
          />
        ))}
      </Box>
    </Box>
  );
}
